import React, { useState } from "react";
import ArchivedLeaveCancellationTable from './Components/ArchivedLeaveCancellationTable'
import LeaveCancellationRequestTable from './Components/LeaveCancellationRequestTable'

const LeaveCancellationRequest = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    return (
        <>
            <div className="px-xl-5 px-lg-4 px-3 py-3 page-body leave-management-page leave-module-shell">
                <div className="leave-page-header d-flex align-items-start justify-content-between flex-wrap gap-3 mb-4">
                    <div>
                        <span className="leave-page-kicker">Leave Cancellation</span>
                        <h3 className="fw-bold mb-1 leave-page-title">Cancellation Request</h3>
                        <p className="mb-0 leave-page-description">
                            Review pending cancellation requests and take action.
                        </p>
                    </div>
                </div>
                <div className="row g-4">
                    <div className="col-sm-12">
                        <div className="card leave-surface-card">
                            <div className="card-body leave-surface-body">
                                <LeaveCancellationRequestTable
                                    onDecision={() => setRefreshKey(prev => prev + 1)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="leave-subsection-header mt-2">
                            <h4 className="fw-bold mb-1">Cancellation History</h4>
                            <p className="mb-0 text-muted">
                                View archived approvals and rejections with reasons and decision remarks.
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="card leave-surface-card">
                            <div className="card-body leave-surface-body">
                                <ArchivedLeaveCancellationTable
                                    refreshKey={refreshKey}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LeaveCancellationRequest
